import { render, staticRenderFns } from "./ShowClientInfo.vue?vue&type=template&id=d7b352fc&"
import script from "./ShowClientInfo.vue?vue&type=script&lang=js&"
export * from "./ShowClientInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports